import { useModals } from 'almanac-ui/Modal'
import { ExternalIntegration } from 'api/clients/ExternalIntegrationsClient'
import { ConfirmDisconnectModal } from '../ConfirmDisconnectModal'
import { getIntegrationInfoFromProvider } from 'components/TacticIntegrationList/utils'
import { useDisconnectMultipleIntegrations } from 'hooks/queries/externalIntegrations/useDisconnectMultipleIntegrations'

export const useDisconnectWithConfirmation = (
  matchingIntegrations: ExternalIntegration[],
  { onCancel }: { onCancel?: () => void } = {},
) => {
  const { openModal, closeModal } = useModals()
  const { mutateAsync: disconnectAll } = useDisconnectMultipleIntegrations(matchingIntegrations)

  return (onConfirm: () => void) => {
    if (matchingIntegrations.length > 0) {
      const firstIntegration = matchingIntegrations[0]
      const integrationInfo = getIntegrationInfoFromProvider(firstIntegration.provider)
      const platformName = integrationInfo?.name || 'this platform'

      openModal(ConfirmDisconnectModal, {
        platformName,
        count: matchingIntegrations.length,
        onConfirm: () => {
          closeModal()
          onConfirm()
          disconnectAll()
        },
        onCancel: () => {
          onCancel?.()
          closeModal()
        },
        onPressOutside: () => {
          onCancel?.()
          closeModal()
        },
      })
    } else {
      onConfirm()
    }
  }
}
